import { render, staticRenderFns } from "./IpBlockItem.vue?vue&type=template&id=022b950c&scoped=true"
import script from "./IpBlockItem.vue?vue&type=script&lang=js"
export * from "./IpBlockItem.vue?vue&type=script&lang=js"
import style0 from "./IpBlockItem.vue?vue&type=style&index=0&id=022b950c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b950c",
  null
  
)

export default component.exports